// @flow
import Resource from 'speed-js-core/src/api/Resource';

export default class CurrentAccountsResource extends Resource {
    basePath: string = 'accounts/current_accounts/';

    objectPath: string = 'accounts/current_accounts/{ident}/';

    checkTrialEligibility(): Promise<Object> {
        return this.client._request(`${this._getBasePath()}trial/eligibility/`, 'GET');
    }

    startTrial(): Promise<Object> {
        return this.client._request(`${this._getBasePath()}trial/start/`, 'PATCH');
    }

    acceptTrialInvitation(): Promise<Object> {
        return this.client._request(`${this._getBasePath()}trial/accept-invitation/`, 'PATCH');
    }

    subscribeToTrialQueue(): Promise<Object> {
        return this.client._request(`${this._getBasePath()}trial/queue/`, 'PATCH');
    }
}
